(function(){
    bottleConfig = {
        selector: {
            firstStepProduct: ".js-first-step-product",
            nextStepButton: ".js-next-shield-button",
            retriveDiv: ".js-retrive-div",
            bottleButtonSvg: ".js-bottle-button-svg",
            secondStepButton: ".js-shield-button",
            collectionTabButon : ".js-tab-button",
            shieldCollectionProduct: ".js-shield-collection",
            shieldNavProduct: ".js-shield-nav",
            secondStepProduct: ".js-second-step-product",
            fragranceButton: ".js-fragrance-button",
            shieldButtonSvg: ".js-shield-button-svg",
            bottleButton: ".js-bottle-button",
            fragranceMainTab: ".js-fragrance-tab",
            fragranceCollection: ".js-fragrance-collection",
            fragranceTab: ".js-fragrance-tab-name",
            fragranceTabContains: ".js-fragrance-collection-tab-contain",
            nextFragranceStepButton: ".js-next-fragrance-button",
            finalBottleSelectButton: ".js-final-select-bottle",
            searchButton: ".js-search-button",
            searchInput: ".js-search-input",
            addToCartBtn: ".js-add-to-cart-bundle",
            saveDesignButton: ".js-save-design-button",
            retriveDesignBtn : ".js-retrive-saved-design-button",
            editDesignBtn: ".js-edit-design",
            tabContentBtn: ".js-tab-content-button",
            showShieldTabBtn: ".js-show-shield",
            mobileshieldSelectBtn: ".js-mobile-tab-button",
            showFragranceTabBtn: ".js-show-fragrance",
            showFinalStepTabBtn: ".js-show-final-step",
            shareCreationBtn: ".js-share-creation-btn",
            downloadContentBtn: ".js-download-content"

        },
        init: function(){
            this.firstStepProducts = document.querySelectorAll(this.selector.firstStepProduct);
            this.nextStepButton = document.querySelector(this.selector.nextStepButton);
            this.retriveDiv = document.querySelector(this.selector.retriveDiv);
            this.bottleButtonSvg = document.querySelector(this.selector.bottleButtonSvg);
            this.secondStepButton = document.querySelector(this.selector.secondStepButton);
            this.collectionTabButon = document.querySelectorAll(this.selector.collectionTabButon);
            this.shieldCollectionProduct = document.querySelectorAll(this.selector.shieldCollectionProduct);
            this.shieldNavProduct = document.querySelectorAll(this.selector.shieldNavProduct);
            this.secondStepProduct = document.querySelectorAll(this.selector.secondStepProduct);
            this.fragranceStepButton = document.querySelector(this.selector.fragranceButton);
            this.shieldButtonSvg = document.querySelector(this.selector.shieldButtonSvg);
            this.bottlestepButton = document.querySelector(this.selector.bottleButton);
            this.bottleProductTab = document.querySelector(".js-bottle-tab");
            this.fragranceTabMain = document.querySelector(this.selector.fragranceMainTab);
            this.FragranceCollectionProduct = document.querySelector(this.selector.fragranceCollection);
            this.fragranceTabs = document.querySelectorAll(this.selector.fragranceTab);
            this.fragranceTabContains = document.querySelectorAll(this.selector.fragranceTabContains);
            this.fragranceNextButton = document.querySelector(this.selector.nextFragranceStepButton);
            this.finalizeBottleNextButton = document.querySelector(this.selector.finalBottleSelectButton);
            this.searchButton = document.querySelector(this.selector.searchButton);
            this.searchInput = document.querySelector(this.selector.searchInput);
            this.addToCartButtton = document.querySelector(this.selector.addToCartBtn);
            this.saveDesignBtn = document.querySelector(this.selector.saveDesignButton);
            this.retriveDesignButton = document.querySelector(this.selector.retriveDesignBtn);
            this.editDesignButton = document.querySelector(this.selector.editDesignBtn);
            this.tabContentButton = document.querySelector(this.selector.tabContentBtn);
            this.showShieldTabButton = document.querySelector(this.selector.showShieldTabBtn);
            this.mobileshieldSelectButton = document.querySelectorAll(this.selector.mobileshieldSelectBtn);
            this.showFragranceTabButton = document.querySelector(this.selector.showFragranceTabBtn);
            this.showFinalStepTabButton = document.querySelector(this.selector.showFinalStepTabBtn);
            this.shareCreationButton = document.querySelector(this.selector.shareCreationBtn);
            this.downloadContentButtons = document.querySelectorAll(this.selector.downloadContentBtn);
            this.saveDesignArray = [];
            this.bindEvent();
        },
        bindEvent: function(){
            const _this = this;
            this.firstStepProducts.forEach((product) => product.addEventListener("click",_this.firstStepProductSelector.bind(this),true));
            this.secondStepButton.addEventListener("click",_this.showSecondStep.bind(this),true);
            this.nextStepButton.addEventListener("click",_this.showSecondStep.bind(this),true);
            this.collectionTabButon.forEach((button) => button.addEventListener("click",_this.shieldTabChange.bind(this),true));
            this.shieldNavProduct.forEach((product) => product.addEventListener("click",_this.secondStepProductSelector.bind(this),true));
            this.fragranceStepButton.addEventListener("click",_this.showThirdStep.bind(this),true);
            this.fragranceNextButton.addEventListener("click",_this.showThirdStep.bind(this),true);
            this.bottlestepButton.addEventListener("click",_this.showFirstStep.bind(this),true);
            this.fragranceTabs.forEach((tab) => tab.addEventListener("click",_this.ThirdStepProductShow.bind(this),true));
            this.fragranceTabContains.forEach((contains) => contains.addEventListener("click",_this.ThirdStepProductSelector.bind(this),true));
            this.finalizeBottleNextButton.addEventListener("click",_this.finalStepShow.bind(this),true);
            this.searchButton.addEventListener("click",_this.searchInputShow.bind(this),true);
            this.searchInput.addEventListener("input",_this.searchProduct.bind(this),true);
            this.addToCartButtton.addEventListener("click",_this.addToCartProduct.bind(this),false);
            this.saveDesignBtn.addEventListener("click",_this.saveDesign.bind(this),false);
            this.retriveDesignButton.addEventListener("click",_this.finalStepShow.bind(this),false);
            this.editDesignButton.addEventListener("click",_this.editDesign.bind(this),false);
            this.tabContentButton.addEventListener("click",_this.tabContentShowHide.bind(this),false);
            this.showShieldTabButton.addEventListener("click",_this.shieldTabShow.bind(this),false);
            this.showFragranceTabButton.addEventListener("click",_this.showThirdStep.bind(this),false);
            this.showFinalStepTabButton.addEventListener("click",_this.finalStepShow.bind(this),false);
            this.shareCreationButton.addEventListener("click",this.showSharePopup.bind(true),false);
            this.downloadContentButtons.forEach((downloadContentButton) => downloadContentButton.addEventListener("click",this.downloadContentImage.bind(true),false));
            document.querySelector(".js-back-bottle").addEventListener("click",_this.backToBottleTab.bind(this),false);
            document.querySelector(".js-back-shield").addEventListener("click",_this.backToShieldTab.bind(this),false);
            document.querySelectorAll(".js-mobile-tab-button").forEach((mobileshieldSelectButton)=>mobileshieldSelectButton.addEventListener("click",_this.shieldSelectTab.bind(this),false));
            document.querySelector(".js-fragrance-tab-title").querySelectorAll("div").forEach((contains) => contains.addEventListener("click",_this.ThirdStepProductShow.bind(this),true));
            document.querySelector(".js-back-to-scent").addEventListener("click",(event)=>{
                document.querySelector(".js-all-collection").classList.remove("hidden");
                document.querySelector(".js-fragrance-tab-title").classList.add("hidden");
                event.target.classList.add("hidden");
                this.searchInput.classList.add("hidden");
                this.searchButton.classList.remove("hidden");
                document.querySelector(".js-fragrance-collection-tab").classList.add("hidden");
                document.querySelectorAll(".js-fragrance-collection-tab-contain").forEach((div)=>div.classList.add("hidden"));
                document.querySelector(".js-product-select-nav").classList.remove("sub-menu-open");
                document.querySelector(".sub-tab-list").classList.add("hidden");
                document.querySelector(".js-search-input").querySelector("input").value = '';
            });
            document.querySelector(".js-shield-model-open-button").addEventListener("click",(event)=>{
                document.querySelector(".bottle_information").classList.add("open-model");
                document.querySelector(".js-sheild-product-details-model").classList.remove("hidden");
            });
            document.querySelector(".js-fragrance-model-open-button").addEventListener("click",(event)=>{
               document.querySelector(".bottle_information").classList.add("open-model");
               document.querySelector(".js-fragrance-product-details-model").classList.remove("hidden");
            });
            document.querySelector(".js-shield-model-close").addEventListener("click",(event)=>{
                document.querySelector(".bottle_information").classList.remove("open-model");
                document.querySelector(".js-sheild-product-details-model").classList.add("hidden");
            });
            document.querySelector(".js-fragrance-model-close").addEventListener("click",(event)=>{
               document.querySelector(".bottle_information").classList.remove("open-model");
               document.querySelector(".js-fragrance-product-details-model").classList.add("hidden");
            });
            document.querySelector(".js-mobiile-shield-tab-back-button").addEventListener("click",(event)=>{
                document.querySelector(".js-mobile-sub-nav").classList.remove("hidden");
                _this.shieldCollectionProduct.forEach((pd)=>pd.classList.add("hidden"));
                document.querySelector(".sub-tab-list").classList.add("hidden");
                document.querySelector(".js-product-select-nav").classList.remove("sub-menu-open");
            });
            document.querySelector(".js-cancel-button").addEventListener("click",(event) => {
                document.querySelector(".js-share-image-model-main").classList.add("hidden");
                document.querySelector("body").classList.remove("share_content_model_open");
            });

            this.loadFromLocalStorage();
            this.clearLocalStorage();
        },
        loadFromLocalStorage: function(){
            if(localStorage.getItem("save-design") != null){
                document.querySelector(".js-retrive-div").classList.remove("hidden");
            }
        },
        clearLocalStorage: function(){
            localStorage.removeItem("first-step-product");
            localStorage.removeItem("second-step-product");
            localStorage.removeItem("third-step-product");
        },
        firstStepProductSelector: function(event){
            const _this = this;
            const productHandle = JSON.parse(event.target.closest(_this.selector.firstStepProduct).getAttribute("data-product-json"));
            if(this.bottleButtonSvg.classList.contains("hidden")==true){

                _this.nextStepButton.classList.remove("hidden");
            }
            _this.retriveDiv.classList.add("hidden");   
            _this.bottleButtonSvg.classList.remove("hidden");
            _this.secondStepButton.removeAttribute("disabled");
            _this.secondStepButton.removeAttribute("aria-disabled");
            document.querySelector(".js-show-shield").removeAttribute("disabled"); 
            document.querySelector(".js-retrive-div").classList.add("hidden");
            document.querySelector(".js-bottle-tab").classList.remove("not-selected");
            localStorage.setItem("first-step-product",JSON.stringify(productHandle));
            
        },
        showFirstStep: function(event){
            const _this = this;
            _this.bottleProductTab.classList.remove("hidden");
            _this.bottlestepButton.setAttribute("aria-selected", true);
            _this.secondStepButton.removeAttribute("aria-selected");
            _this.fragranceStepButton.removeAttribute("aria-selected");
            $(`.slider-nav `).slick('refresh');
            _this.collectionTabButon.forEach((button)=>button.classList.add("hidden"));
            // _this.shieldCollectionProduct.forEach((pd)=>pd.classList.add("hidden"));
            _this.shieldNavProduct.forEach((nav)=>nav.classList.add("hidden"));
            _this.fragranceTabMain.classList.add("hidden");
            document.querySelector(".js-select-sheild-notification").classList.add("hidden");
            document.querySelector(".js-select-fragrance-notification").classList.add("hidden");
            document.querySelector(".js-final-select-bottle").classList.add("hidden");
            document.querySelectorAll(".js-fragrance-collection-tab-contain").forEach((product)=>{
                  product.classList.add("hidden");
            });
            document.querySelector(".js-search-input").classList.add("hidden");
            document.querySelector(".js-search-input").querySelector("input").value = '';
            document.querySelectorAll(".js-fragrance-collection-tab-contain").forEach((nav)=>{
                nav.classList.add("hidden");
            })
            document.querySelector(".back_to_fragrance").classList.add("hidden");
            document.querySelector(".js-fragrance-product-details-model").classList.add("hidden");
            document.querySelector(".js-fragrance-model-open-button").classList.add("hidden");
            document.querySelector(".js-shield-model-open-button").classList.add("hidden");
             
            if(document.querySelector(".js-fragrance-button-svg").classList.contains("hidden") == false){
                document.querySelector(".js-fragrance-tab-title").classList.add("hidden");
                document.querySelector(".js-back-to-scent").classList.add("hidden");
                _this.nextStepButton.classList.remove("hidden");
                document.querySelector(".js-next-fragrance-button").classList.add("hidden");
            }
            this.searchButton.classList.remove("hidden");
        },
        showSecondStep: function(event){
            const _this = this;
            _this.collectionTabButon.forEach((button)=>button.classList.remove("hidden"));
            _this.nextStepButton.classList.add("hidden");
            _this.secondStepButton.setAttribute("aria-selected", true);
            _this.bottlestepButton.removeAttribute("aria-selected");
            _this.fragranceStepButton.removeAttribute("aria-selected");
            _this.collectionTabButon.forEach((button,index)=>{
                if(button.classList.contains("active") == true){
                    _this.shieldCollectionProduct[index-1].classList.remove("hidden");
                    _this.shieldNavProduct[index - 1].classList.remove("hidden");
                    button.click();
                    $(`.slider-nav-second-${button.getAttribute("data-collection")}`).slick('refresh');
                    $(`.slider-second-${button.getAttribute("data-collection")}`).slick('refresh');
                }
            });
            document.querySelector(".js-search-input").classList.add("hidden");
            document.querySelector(".js-search-input").querySelector("input").value = '';
            document.querySelectorAll(".js-fragrance-collection-tab-contain").forEach((nav)=>{
                nav.classList.add("hidden");
            })
            document.querySelector(".js-fragrance-collection-tab").classList.add("hidden");
            document.querySelector(".js-shield-model-open-button").classList.remove("hidden");
            document.querySelector(".js-fragrance-model-open-button").classList.add("hidden");
            document.querySelector(".sub-tab-list").classList.remove("hidden");
            
            document.querySelector(".back_to_fragrance").classList.add("hidden");
            _this.bottleProductTab.classList.add("hidden");
            _this.fragranceStepButton.removeAttribute("aria-disabled");
            _this.fragranceTabMain.classList.add("hidden");
            if(document.querySelector(".js-shield-button-svg").classList.contains("hidden") == true){

                document.querySelector(".js-select-sheild-notification").classList.remove("hidden");
            }
            document.querySelector(".js-fragrance-product-details-model").classList.add("hidden");
            document.querySelector(".js-select-fragrance-notification").classList.add("hidden");
            document.querySelectorAll(".js-fragrance-collection-tab-contain").forEach((product)=>{
                product.classList.add("hidden");
            });
            if(document.querySelector(".js-fragrance-button-svg").classList.contains("hidden") == false){
                document.querySelector(".js-fragrance-tab-title").classList.add("hidden");
                document.querySelector(".js-back-to-scent").classList.add("hidden");
                _this.fragranceNextButton.classList.remove("hidden");
                document.querySelector(".js-final-select-bottle").classList.add("hidden");
            }
            this.searchButton.classList.remove("hidden");
           
        },
        showThirdStep: function(event){
            const _this = this;
            _this.fragranceTabMain.classList.remove("hidden");
            _this.collectionTabButon.forEach((button)=>button.classList.add("hidden"));
            _this.shieldNavProduct.forEach((nav)=>nav.classList.add("hidden"));
            _this.fragranceNextButton.classList.add("hidden");
            _this.fragranceStepButton.setAttribute("aria-selected", true);
            _this.bottlestepButton.removeAttribute("aria-selected");
            _this.secondStepButton.removeAttribute("aria-selected");
            
            document.querySelector(".js-shield-model-open-button").classList.add("hidden");
            if(document.querySelector(".js-all-collection").classList.contains("hidden") == true){

                document.querySelector(".back_to_fragrance").classList.add("hidden");
            }
            this.searchButton.classList.remove("hidden");
            document.querySelector(".js-product-select-nav").classList.contains("hide-slider-tabs") == true ? document.querySelector(".js-product-select-nav").classList.remove("hide-slider-tabs") : '';
            document.querySelector("body").classList.contains("hide-slider-tabs") == true ? document.querySelector("body").classList.remove("hide-slider-tabs") : '';
            document.querySelector(".js-mobile-sub-nav").classList.add("hidden");
            document.querySelector(".js-back-bottle").classList.add("hidden");
            document.querySelector(".js-back-shield").classList.remove("hidden");
            document.querySelector(".js-next-shield-button").classList.add("hidden");

            document.querySelector(".js-back-shield").removeAttribute("disabled");
            document.querySelector(".sub-tab-list").classList.add("hidden");
            document.querySelector(".js-product-select-nav").classList.remove("sub-menu-open");
            this.bottleProductTab.classList.add("hidden");
            document.querySelector(".js-all-collection").classList.remove("hidden");
            if(document.querySelector(".js-fragrance-button-svg").classList.contains("hidden") == true){
                document.querySelector(".js-select-fragrance-notification").classList.remove("hidden");
                document.querySelector(".js-fragrance-tab-title").classList.add("hidden");
                document.querySelector(".js-back-to-scent").classList.add("hidden");
            }else{
                document.querySelector(".js-fragrance-tab-title").classList.remove("hidden");
                document.querySelector(".js-back-to-scent").classList.remove("hidden");
               document.querySelector(".js-fragrance-collection-tab").classList.add("hidden");
               _this.finalizeBottleNextButton.classList.remove("hidden");
            }
            
            document.querySelector(".js-sheild-product-details-model").classList.add("hidden");
            document.querySelector(".js-select-sheild-notification").classList.add("hidden");
            document.querySelectorAll(".js-fragrance-collection-tab-contain").forEach((product)=>{
                if(product.classList.contains("slick-current") === true && document.querySelector(".js-fragrance-button-svg").classList.contains("hidden") == false){
                   product.classList.remove("hidden");
                //    $(`.slider-nav-third`).slick('refresh');
                }
            });
            document.querySelector(".js-show-fragrance").classList.add("hidden");
            document.querySelector(".js-show-final-step").classList.remove("hidden");
            document.querySelector(".js-shield-tab-title").classList.add("hidden");
            document.querySelector(".js-fragrance-mobile-tab-title").classList.remove("hidden");
            
            
        },
        shieldTabChange: function(event){
            const _this = this;
            _this.collectionTabButon.forEach((button)=>button.classList.remove("active"));
            event.target.closest(".js-tab-button").classList.add("active");
            _this.shieldCollectionProduct.forEach((pd)=>pd.classList.add("hidden"));
            _this.shieldNavProduct.forEach((nav)=>nav.classList.add("hidden"));
            if(event.target.closest(".js-tab-button").classList.contains("active") == true){
                _this.shieldCollectionProduct.forEach((pd)=> pd.getAttribute("data-collection") == event.target.closest(".js-tab-button").getAttribute("data-collection") ? pd.classList.remove("hidden") : pd.classList.add("hidden"));
                _this.shieldNavProduct.forEach((nav)=>nav.getAttribute("data-collection") == event.target.closest(".js-tab-button").getAttribute("data-collection")? nav.classList.remove("hidden") : nav.classList.add("hidden"));               
            }
            $(`.slider-nav-second-${event.target.closest(".js-tab-button").getAttribute("data-collection")}`).slick('refresh');
            $(`.slider-second-${event.target.closest(".js-tab-button").getAttribute("data-collection")}`).slick('refresh');
            // _this.collectionTabButon.forEach((button,index)=>{
                
            // });
        },
        secondStepProductSelector: function(event){
            const _this = this;
            const productHandle = JSON.parse(event.target.closest(_this.selector.secondStepProduct).getAttribute("data-product-json"));
            const productTitle = event.target.closest(_this.selector.secondStepProduct).getAttribute("data-title");
            const productDescription = event.target.closest(_this.selector.secondStepProduct).getAttribute("data-description");
            const productPrice = event.target.closest(_this.selector.secondStepProduct).getAttribute("data-price");
            const productTag = event.target.closest(_this.selector.secondStepProduct).getAttribute("data-tag");
            const splitTag = productTag.split("sh_")
            _this.fragranceStepButton.removeAttribute("disabled");
            _this.shieldButtonSvg.classList.remove("hidden");
            localStorage.setItem("second-step-product",JSON.stringify(productHandle));
            _this.fragranceNextButton.classList.remove("hidden");
            document.querySelector(".js-show-fragrance").removeAttribute("disabled");
            document.querySelector(".js-final-select-bottle").classList.add("hidden");
            document.querySelector(".js-select-sheild-notification").classList.add("hidden");
            document.querySelector(".js-sheild-product-details-model").classList.remove("hidden");
            document.querySelector(".js-sheild-product-details-model").querySelector(".js-title").innerHTML = productTitle;
            document.querySelector(".js-sheild-product-details-model").querySelector(".js-description").innerHTML = productDescription;
            document.querySelector(".js-sheild-product-details-model").querySelector(".js-price").innerHTML = productPrice;
            if(document.querySelector(".js-slider-box-bottle").classList.contains("gold") === true || document.querySelector(".js-slider-box-bottle").classList.contains("silver") || document.querySelector(".js-slider-box-bottle").classList.contains("rose_gold")){
                document.querySelector(".js-slider-box-bottle").classList.remove("gold");
                document.querySelector(".js-slider-box-bottle").classList.remove("silver");
                document.querySelector(".js-slider-box-bottle").classList.remove("rose_gold");
                document.querySelector(".js-first-product-image").classList.remove("gold");
                document.querySelector(".js-first-product-image").classList.remove("silver");
                document.querySelector(".js-first-product-image").classList.remove("rose_gold");
                
            }
            document.querySelector(".js-slider-box-bottle").classList.add(`${splitTag[1]}`);
            document.querySelector(".js-first-product-image").classList.add(`${splitTag[1]}`);
            document.querySelector(".js-shield-tab").classList.remove("not-selected");
        },
        ThirdStepProductShow: function(event){
            const _this = this;
            const title = event.target.closest(_this.selector.fragranceTab) ? event.target.closest(_this.selector.fragranceTab).getAttribute("data-collection") : event.target.getAttribute("data-collection");
            document.querySelector(".sub-tab-list").classList.remove("hidden");
            document.querySelector(".js-all-collection").classList.add("hidden");
            document.querySelector(".js-fragrance-tab-title").classList.remove("hidden");
            document.querySelector(".js-back-to-scent").classList.remove("hidden");
            document.querySelector(".js-fragrance-collection-tab").classList.remove("hidden");
            document.querySelector(".back_to_fragrance").classList.remove("hidden");
            _this.searchInput.classList.add("hidden");
            _this.FragranceCollectionProduct.classList.remove("hidden");
            $(`.slider-third`).slick('refresh');
            _this.fragranceTabContains.forEach((tab) => {
                if(tab.getAttribute("data-collection") == title){
                    tab.classList.remove("hidden");
                    $(`.slider-nav-third`).slick('refresh');
                    // console.log(tab)
                    // setTimeout(()=>{
                    //     tab.click();
                    // },500)
                }else{

                    tab.classList.add("hidden");
                }
            });
            document.querySelector(".js-product-select-nav").classList.add("sub-menu-open");
            document.querySelector(".js-fragrance-tab-title").querySelectorAll("div").forEach((div) => {
                div.classList.remove("active");
                if(div.getAttribute("data-collection") == title){
                    div.classList.add("active");
                };
            })
        },
        ThirdStepProductSelector: function(event){
            const _this = this;
            const productHandle = JSON.parse(event.target.closest(_this.selector.fragranceTabContains).getAttribute("data-product-json"));
            const productTitle = event.target.closest(_this.selector.fragranceTabContains).getAttribute("data-title");
            const productDescription = event.target.closest(".js-fragrance-collection-tab").querySelectorAll(".js-fragrance-ingredients-metafield-value");
            const productIngredients = event.target.closest(".js-fragrance-collection-tab").querySelectorAll(".js-fragrance-fragrance-ingredients-metafield-value")
            const productPrice = event.target.closest(_this.selector.fragranceTabContains).getAttribute("data-price");
            document.querySelector(".js-fragrance-model-open-button").classList.remove("hidden");
            document.querySelector(".js-fragrance-button-svg").classList.remove("hidden");
            localStorage.setItem("third-step-product",JSON.stringify(productHandle));
            _this.finalizeBottleNextButton.classList.remove("hidden");
            document.querySelector(".js-select-fragrance-notification").classList.add("hidden");
            document.querySelector(".js-fragrance-product-details-model").classList.remove("hidden");
            document.querySelector(".js-fragrance-product-details-model").querySelector(".js-title").innerHTML = productTitle;
            document.querySelector(".js-show-final-step").removeAttribute("disabled");
            productDescription.forEach((des)=>{
                if(des.getAttribute("data-title") === productTitle){
                    document.querySelector(".js-fragrance-product-details-model").querySelector(".js-description").innerHTML = des.innerText;
                }
            })
            document.querySelector(".js-fragrance-product-details-model").querySelector(".js-price").innerHTML = productPrice;
            document.querySelector(".js-fragrance-ingredients-div").innerHTML = '';
            document.querySelector(".js-fragrance-collection-tab").classList.remove("not-selected");
            productIngredients.forEach((ing)=>{
                if(ing.getAttribute("data-title") === productTitle){
                    ing.querySelectorAll(".js-image").forEach((image,index) => {
                        let newHtml = ` <div class="fragrance-ingredients">
                        <span>
                        <img src="${image.innerText}" decoding="async" data-nimg="fill">
                        </span>
                        <h5>${ing.querySelectorAll(".js-title")[index].innerText}</h5>
                        </div>`
                        document.querySelector(".js-fragrance-ingredients-div").insertAdjacentHTML("afterbegin",newHtml);
                    });
                }
            })
        },
        searchInputShow: function(event){
            const _this = this;
            this.searchInput.classList.remove("hidden");
            _this.searchButton.classList.add("hidden");
            document.querySelector(".js-all-collection").classList.add("hidden");
            document.querySelector(".js-fragrance-tab-title").classList.remove("hidden");
            document.querySelector(".js-back-to-scent").classList.remove("hidden");   
            document.querySelector(".js-fragrance-collection-tab").classList.remove("hidden");
            document.querySelector(".back_to_fragrance").classList.remove("hidden");
            document.querySelector(".sub-tab-list").classList.remove("hidden");
            document.querySelector(".js-product-select-nav").classList.add("sub-menu-open");
        },
        searchProduct: function(event){
            const _this = this;
            const value = event.target.value;
            document.querySelectorAll(".js-fragrance-collection-tab-contain").forEach((product)=>{
                if(product.getAttribute("data-title-handle").includes(value) == true && value !== ''){
                   product.classList.remove("hidden");
                   $(`.slider-nav-third`).slick('refresh');
                }else{
                  product.classList.add("hidden");
                }
            });
        },
        finalStepShow: function(event){
            const _this = this;
            document.querySelector(".js-product-select-step").classList.add("hidden");
            document.querySelector(".js-product-select-nav").classList.add("hidden");
            document.querySelector(".js-final-step-main-div").classList.remove("hidden");
            let leftSideProductInfo = document.querySelector(".js-product-info");
            let firstProduct = document.querySelector(".js-first-step");
            let secondProduct = document.querySelector(".js-second-step");
            let thirdProduct = document.querySelector(".js-third-step");
            document.querySelector(".js-product-select-nav").classList.remove("sub-menu-open");
            const firstProductJson = JSON.parse(localStorage.getItem("first-step-product")) ? JSON.parse(localStorage.getItem("first-step-product")) : JSON.parse(localStorage.getItem("save-design"))[0];
            const secondProductJson = JSON.parse(localStorage.getItem("second-step-product")) ? JSON.parse(localStorage.getItem("second-step-product")): JSON.parse(localStorage.getItem("save-design"))[1];
            const thirdProductJson = JSON.parse(localStorage.getItem("third-step-product")) ? JSON.parse(localStorage.getItem("third-step-product")) : JSON.parse(localStorage.getItem("save-design"))[2];
            let firstProductHtml = `<div type="Bottle" class="image">
                        <span>
                            <img src="${firstProductJson.featured_image}" decoding="async" data-nimg="fill" sizes="100vw">
                        </span>
                    </div>
                    <div class="details-main">
                        <div class="title">
                            <p class="main_lable">
                                Bottle:
                            </p>
                            <p class="sub_lable">
                            ${firstProductJson.title}
                            </p>
                        </div>
                        <p class="text price">${Shopify.formatMoney(firstProductJson.price)}</p>
                    </div>`;
            firstProduct.innerHTML = firstProductHtml;
            let secondProductHtml = `<div type="Bottle" class="image">
                        <span>
                            <img src="${secondProductJson.featured_image}" decoding="async" data-nimg="fill" sizes="100vw">
                        </span>
                    </div>
                    <div class="details-main">
                        <div class="title">
                            <p class="main_lable">
                                Bottle:
                            </p>
                            <p class="sub_lable">
                            ${secondProductJson.title}
                            </p>
                        </div>
                        <p class="text price">${Shopify.formatMoney(secondProductJson.price)}</p>
                    </div>`;
            secondProduct.innerHTML = secondProductHtml;
            let thirdProductHtml = `<div type="Bottle" class="image">
                        <span>
                            <img src="${thirdProductJson.featured_image}" decoding="async" data-nimg="fill" sizes="100vw">
                        </span>
                    </div>
                    <div class="details-main">
                        <div class="title">
                            <p class="main_lable">
                                Bottle:
                            </p>
                            <p class="sub_lable">
                            ${thirdProductJson.title}
                            </p>
                        </div>
                        <p class="text price">${Shopify.formatMoney(thirdProductJson.price)}</p>
                    </div>`;
            thirdProduct.innerHTML = thirdProductHtml;
            const totalPrice = Shopify.formatMoney(firstProductJson.price + secondProductJson.price + thirdProductJson.price);
            document.querySelector(".js-total-price").innerHTML = totalPrice;
            const firstProductImage = document.querySelector(".js-first-product-image").querySelector("img");
            const secondProductImage = document.querySelector(".js-second-product-image").querySelector("img");
            const thirdProductImage = document.querySelector(".js-third-product-image").querySelector("img");
            firstProductImage.src = firstProductJson.featured_image;
            secondProductImage.src = secondProductJson.featured_image;
            thirdProductImage.src = thirdProductJson.featured_image;
            document.querySelector(".mobile_tabs").classList.add("hidden");
            if(JSON.parse(localStorage.getItem("second-step-product")) === null){
                let tag = JSON.parse(localStorage.getItem("save-design"))[1].tags.find((arr)=>arr.includes("sh_"));
                let splitTag = tag.split("sh_");
                document.querySelector(".js-first-product-image").classList.add(`${splitTag[1]}`);
            }
        },
        addToCartProduct: async function(event){
            const _this = this;
            const firstProductJson = JSON.parse(localStorage.getItem("first-step-product")) ? JSON.parse(localStorage.getItem("first-step-product")) : JSON.parse(localStorage.getItem("save-design"))[0];
            const secondProductJson = JSON.parse(localStorage.getItem("second-step-product")) ? JSON.parse(localStorage.getItem("second-step-product")): JSON.parse(localStorage.getItem("save-design"))[1];
            const thirdProductJson = JSON.parse(localStorage.getItem("third-step-product")) ? JSON.parse(localStorage.getItem("third-step-product")) : JSON.parse(localStorage.getItem("save-design"))[2];
            const mainProductJson = window.customProduct.mainbottleConfigProduct;
            document.querySelector(this.selector.addToCartBtn).innerHTML = 'Adding To Bag';
            document.querySelector(this.selector.addToCartBtn).setAttribute("disabled", true);
            let mainProduct = { items: [] };
            let AllProperty = [];
            let mainProductArray = [];
            let firstProduct = [];
            let secondProduct = [];
            let thirdProduct = [];
            const uniqueBundleId = (Date.now()).toString();
            const formData1 = { items: [{
                id: firstProductJson.variants[0].id,
                quantity: 1,
                properties: { title: 'first_product', "unique_id": "main_product", _bundleId: uniqueBundleId }
            }] };
            const formData2 = { items: [{
                id: secondProductJson.variants[0].id,
                quantity: 1,
                properties: { title: 'second_product', "unique_id": "main_product", _bundleId: uniqueBundleId }
            }] };
            const formData3 = { items: [{
                id: thirdProductJson.variants[0].id,
                quantity: 1,
                properties: { title: 'third_product', "unique_id": "main_product", _bundleId: uniqueBundleId }
            }] };
            AllProperty.push({ title: firstProductJson.title, price: Shopify.formatMoney(firstProductJson.price) },{ title: secondProductJson.title, price: Shopify.formatMoney(secondProductJson.price) },{ title: thirdProductJson.title, price: Shopify.formatMoney(thirdProductJson.price) });
            mainProductArray.push({
                id: window.customProduct.mainbottleConfigProduct.variants[0].id,
                quantity: 1,
                properties: { AllProperty,"unique_id": "main_product", _bundleId: uniqueBundleId }
            });           
            const processBottleProducts = async () => {
                try {
                    if (formData1.items.length !== 0) {
                       

                        console.log('Adding fragrance products to cart:', formData1.items);

                        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(formData1)
                        });

                      if (!response.ok) {
                            const errorMessage = await response.text();  // Capture the error message
                            const errorData = JSON.parse(errorMessage);  // Parse the JSON response
                            
                            // Set the error message in the .error_text element
                            document.querySelector(".error_text").innerText = errorData.message;
                            document.querySelector(".error_text").classList.remove("hidden");
                            
                            // Throw the error to propagate it further
                            throw new Error(errorData.message);
                        }
                        
                        return response.json();
                    }

                    return Promise.resolve();
                    
                } catch (error) {
                    console.error('Error processing main product:', error);
                    
                    // Extract the error message from the error object
                    const errorMessage = error.message || 'An unexpected error occurred.';
                    
                    // Set the error message as the innerText of the .error_text element
                    document.querySelector(".error_text").innerText = errorMessage;
                    
                    // Remove the "hidden" class to make the error message visible
                    document.querySelector(".error_text").classList.remove("hidden");
                    
                    // Re-throw the error to propagate it further if needed
                    throw error;
                }
            };
            const processShieldProduct = async () => {
                try {
                   
                    console.log('Adding case product to cart:', formData2.items);
                    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(formData2)
                    });

                     if (!response.ok) {
                            const errorMessage = await response.text();  // Capture the error message
                            const errorData = JSON.parse(errorMessage);  // Parse the JSON response
                            
                            // Set the error message in the .error_text element
                            document.querySelector(".error_text").innerText = errorData.message;
                            document.querySelector(".error_text").classList.remove("hidden");
                            
                            // Throw the error to propagate it further
                            throw new Error(errorData.message);
                        }
                  
                    return response.json();
                } catch (error) {
                  console.error('Error processing main product:', error);
                  
                  // Extract the error message from the error object
                  const errorMessage = error.message || 'An unexpected error occurred.';
                  
                  // Set the error message as the innerText of the .error_text element
                  document.querySelector(".error_text").innerText = errorMessage;
                  
                  // Remove the "hidden" class to make the error message visible
                  document.querySelector(".error_text").classList.remove("hidden");
                  
                  // Re-throw the error to propagate it further if needed
                  throw error;
              }
            };
            const processFragranceProduct = async () => {
                try {
                   
                    console.log('Adding case product to cart:', formData3.items);
                    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(formData3)
                    });

                    if (!response.ok) {
                            const errorMessage = await response.text();  // Capture the error message
                            const errorData = JSON.parse(errorMessage);  // Parse the JSON response
                            
                            // Set the error message in the .error_text element
                            document.querySelector(".error_text").innerText = errorData.message;
                            document.querySelector(".error_text").classList.remove("hidden");
                            
                            // Throw the error to propagate it further
                            throw new Error(errorData.message);
                        }
                    
                    return response.json();
                  } catch (error) {
                    console.error('Error processing main product:', error);
                    
                    // Extract the error message from the error object
                    const errorMessage = error.message || 'An unexpected error occurred.';
                    
                    // Set the error message as the innerText of the .error_text element
                    document.querySelector(".error_text").innerText = errorMessage;
                    
                    // Remove the "hidden" class to make the error message visible
                    document.querySelector(".error_text").classList.remove("hidden");
                    
                    // Re-throw the error to propagate it further if needed
                    throw error;
                }
            };
            const processMainProduct = async () => {
                try {
                    mainProduct.items = mainProductArray;
                    console.log('Adding main product to cart:', mainProduct.items);
                    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(mainProduct)
                    });

                     if (!response.ok) {
                            const errorMessage = await response.text();  // Capture the error message
                            const errorData = JSON.parse(errorMessage);  // Parse the JSON response
                            
                            // Set the error message in the .error_text element
                            document.querySelector(".error_text").innerText = errorData.message;
                            document.querySelector(".error_text").classList.remove("hidden");
                            
                            // Throw the error to propagate it further
                            throw new Error(errorData.message);
                        }
                   
                    return response.json();
                } catch (error) {
                    console.error('Error processing main product:', error);
                    
                    // Extract the error message from the error object
                    const errorMessage = error.message || 'An unexpected error occurred.';
                    
                    // Set the error message as the innerText of the .error_text element
                    document.querySelector(".error_text").innerText = errorMessage;
                    
                    // Remove the "hidden" class to make the error message visible
                    document.querySelector(".error_text").classList.remove("hidden");
                    
                    // Re-throw the error to propagate it further if needed
                    throw error;
                }
            };
            try {
                
                // Process Bottle products
                await processBottleProducts();
                
                // Process Shield product
                await processShieldProduct();
                
                // Process Fragrance product
                await processFragranceProduct();
                
                // Process main product first
                await processMainProduct();

                console.log('All products added successfully');

                setTimeout(() => {
                    // Uncomment to redirect the user to the cart
                    window.location.href = window.Shopify.routes.root + 'cart';
               
                    
                    // window.getCartJson(mainProduct.items[0].id, mainProduct.items[0].quantity,cartJson);
                }, 1500);

            } catch (error) {
                console.error('Error processing main product:', error);
                
                // Extract the error message from the error object
                const errorMessage = error.message || 'An unexpected error occurred.';
                
                // Set the error message as the innerText of the .error_text element
                document.querySelector(".error_text").innerText = errorMessage;
                
                // Remove the "hidden" class to make the error message visible
                document.querySelector(".error_text").classList.remove("hidden");
                
                // Re-throw the error to propagate it further if needed
                throw error;
            }

            console.log(mainProductArray,formData1,formData2,formData3)
        },
        saveDesign: function(event){
            const _this = this;
            const firstProductJson = JSON.parse(localStorage.getItem("first-step-product"));
            const secondProductJson = JSON.parse(localStorage.getItem("second-step-product"));
            const thirdProductJson = JSON.parse(localStorage.getItem("third-step-product"));
            event.target.innerHTML =  "Saving"
            _this.saveDesignArray.push(firstProductJson,secondProductJson,thirdProductJson);
            localStorage.setItem("save-design",JSON.stringify(_this.saveDesignArray));
            setTimeout(()=>{
                event.target.innerHTML = "Save Design"
            },300)
        },
        editDesign: function(event){
            const _this = this;
            const firstProductJson = JSON.parse(localStorage.getItem("first-step-product"));
            const secondProductJson = JSON.parse(localStorage.getItem("second-step-product"));
            const thirdProductJson = JSON.parse(localStorage.getItem("third-step-product"));
            document.querySelector(".mobile_tabs").classList.remove("hidden");
            document.querySelector(".js-fragrance-collection-tab").classList.add("hidden");
            document.querySelector(".js-show-final-step").classList.add("hidden");
            document.querySelector(".js-show-shield").classList.remove("hidden");
            document.querySelector(".js-fragrance-mobile-tab-title").classList.add("hidden");
            document.querySelector(".js-bottle-tab-title").classList.remove("hidden");
            document.querySelector(".js-back-bottle").setAttribute("disabled",true);
            document.querySelector(".js-back-bottle").classList.remove("hidden");
            document.querySelector(".js-back-shield").classList.add("hidden");
            document.querySelector(".sub-tab-list").classList.add("hidden");
            document.querySelector(".js-product-select-nav").classList.contains("hide-slider-tabs") == true ? document.querySelector(".js-product-select-nav").classList.remove("hide-slider-tabs") : '';
            document.querySelector("body").classList.contains("hide-slider-tabs") == true ? document.querySelector("body").classList.remove("hide-slider-tabs") : '';
            if(firstProductJson === null && secondProductJson === null && thirdProductJson === null){
                document.querySelector(".js-product-select-step").classList.remove("hidden");
                document.querySelector(".js-product-select-nav").classList.remove("hidden");
                document.querySelector(".js-final-step-main-div").classList.add("hidden");
                _this.bottlestepButton.click();
                const savedData = JSON.parse(localStorage.getItem("save-design"));
                const firstStepProductHandle = document.querySelectorAll(".js-first-step-product");
                const secondStepProductHandle = document.querySelectorAll(".js-second-step-product");
                const thirdStepProductHandle = document.querySelectorAll(".js-fragrance-collection-tab-contain");

                firstStepProductHandle.forEach(function(pd){
                    if(savedData[0].handle === pd.getAttribute("data-product")){
                        pd.click();
                    }
                });
                secondStepProductHandle.forEach(function(pd){
                    if(savedData[1].handle === pd.getAttribute("data-product")){
                        pd.click();
                    }
                });
                thirdStepProductHandle.forEach(function(pd){
                    if(savedData[2].handle === pd.getAttribute("data-product")){
                        pd.click();
                    }
                });
                document.querySelector(".js-fragrance-button").removeAttribute("aria-disabled");
                document.querySelector(".js-next-fragrance-button").classList.add("hidden");
                document.querySelector(".js-sheild-product-details-model").classList.add("hidden");
                document.querySelector(".js-fragrance-product-details-model").classList.add("hidden");
                document.querySelector(".js-final-select-bottle").classList.add("hidden");
                
                document.querySelectorAll(".js-shield-collection").forEach(function(shield){
                    shield.querySelectorAll(".slick-slide").forEach((slickSlide)=>{

                        console.log(slickSlide.classList.contains("slick-current"));
                        if(slickSlide.classList.contains("slick-current") == true && savedData[1].handle == slickSlide.getAttribute("data-handle")){
                            slickSlide.closest(".js-shield-collection").classList.remove("hidden");
                            const title = shield.getAttribute("data-collection");
                            $(`.slider-second-${title}`).slick('refresh');
                    
                        }
                    })  
                });
                document.querySelector(".js-fragrance-collection").querySelectorAll(".slick-slide").forEach((slickSlide)=>{
                    if(slickSlide.classList.contains("slick-current") == true && savedData[2].handle == slickSlide.getAttribute("data-handle")){
                        slickSlide.closest(".js-fragrance-collection").classList.remove("hidden");
                        $(`.slider-third`).slick('refresh');
                    }
                })
            }else{
                document.querySelector(".js-product-select-step").classList.remove("hidden");
                document.querySelector(".js-product-select-nav").classList.remove("hidden");
                document.querySelector(".js-final-step-main-div").classList.add("hidden");

                _this.bottlestepButton.click();
                
                const firstStepProductHandle = document.querySelectorAll(".js-first-step-product");
                const secondStepProductHandle = document.querySelectorAll(".js-second-step-product");
                const thirdStepProductHandle = document.querySelectorAll(".js-fragrance-collection-tab-contain");
                firstStepProductHandle.forEach(function(pd){
                    if(firstProductJson.handle === pd.getAttribute("data-product")){
                        pd.click();
                    }
                });
                secondStepProductHandle.forEach(function(pd){
                    if(secondProductJson.handle === pd.getAttribute("data-product")){
                        pd.click();
                    }
                });
                thirdStepProductHandle.forEach(function(pd){
                    if(thirdProductJson.handle === pd.getAttribute("data-product")){
                        pd.click();
                    }
                });
                document.querySelector(".js-fragrance-button").removeAttribute("aria-disabled");
                document.querySelector(".js-next-fragrance-button").classList.add("hidden");
                document.querySelector(".js-sheild-product-details-model").classList.add("hidden");
                document.querySelector(".js-fragrance-product-details-model").classList.add("hidden");
                document.querySelector(".js-final-select-bottle").classList.add("hidden");
                
            }
        },
        tabContentShowHide: function(event){
            document.querySelector(".js-product-select-nav").classList.toggle("hide-slider-tabs");
            document.querySelector("body").classList.toggle("hide-slider-tabs");
        },
        shieldTabShow: function(event){
            document.querySelector(".js-bottle-tab").classList.add("hidden");
            document.querySelector(".js-mobile-sub-nav").classList.remove("hidden");
            document.querySelector(".js-show-fragrance").classList.remove("hidden");
            document.querySelector(".js-show-shield").classList.add("hidden");
            document.querySelector(".js-shield-tab-title").classList.remove("hidden");
            document.querySelector(".js-bottle-tab-title").classList.add("hidden");
            document.querySelector(".js-back-bottle").removeAttribute("disabled");
            document.querySelector(".js-product-select-nav").classList.contains("hide-slider-tabs") == true ? document.querySelector(".js-product-select-nav").classList.remove("hide-slider-tabs") : '';
            document.querySelector("body").classList.contains("hide-slider-tabs") == true ? document.querySelector("body").classList.remove("hide-slider-tabs") : '';
        },
        shieldSelectTab: function(event){
            const _this = this;
            const collection = event.target.closest(this.selector.mobileshieldSelectBtn).getAttribute("data-collection");
            document.querySelector(".js-product-select-nav").classList.add("sub-menu-open");
            document.querySelectorAll(".js-tab-button").forEach((nav,i)=>{
                if(nav.getAttribute("data-collection") === collection){
                    nav.click();
                }
            });
            document.querySelector(".sub-tab-list").classList.remove("hidden");
            document.querySelectorAll(".js-tab-button").forEach(((nav)=>{
                nav.classList.remove("hidden");
            }))
            document.querySelector(".js-mobile-sub-nav").classList.add("hidden");
            document.querySelector(".js-product-select-nav").classList.contains("hide-slider-tabs") == true ? document.querySelector(".js-product-select-nav").classList.remove("hide-slider-tabs") : '';
            document.querySelector("body").classList.contains("hide-slider-tabs") == true ? document.querySelector("body").classList.remove("hide-slider-tabs") : '';
        },
        backToBottleTab: function(event){
            $(`.slider-nav `).slick('refresh');
            document.querySelector(".js-bottle-tab").classList.remove("hidden");
            document.querySelector(".js-mobile-sub-nav").classList.add("hidden");
            document.querySelector(".js-show-fragrance").classList.add("hidden");
            document.querySelector(".js-show-shield").classList.remove("hidden");
            document.querySelector(".js-shield-tab-title").classList.add("hidden");
            document.querySelector(".js-bottle-tab-title").classList.remove("hidden");
            document.querySelectorAll(".js-shield-nav").forEach((nav)=>{
                nav.classList.add("hidden");
            });
            document.querySelector(".sub-tab-list").classList.add("hidden");
            document.querySelector(".js-product-select-nav").classList.contains("hide-slider-tabs") == true ? document.querySelector(".js-product-select-nav").classList.remove("hide-slider-tabs") : '';
            document.querySelector("body").classList.contains("hide-slider-tabs") == true ? document.querySelector("body").classList.remove("hide-slider-tabs") : '';
            document.querySelector(".js-product-select-nav").classList.remove("sub-menu-open");
            

        },
        backToShieldTab: function(event){
            document.querySelector(".js-all-collection").classList.add("hidden");
            document.querySelector(".js-fragrance-collection-tab").classList.add("hidden");
            document.querySelector(".js-mobile-sub-nav").classList.remove("hidden");
            document.querySelector(".js-show-fragrance").classList.remove("hidden");
            document.querySelector(".js-show-final-step").classList.add("hidden");
            document.querySelector(".js-back-bottle").classList.remove("hidden");
            document.querySelector(".js-back-shield").classList.add("hidden");
            document.querySelector(".back_to_fragrance").classList.add("hidden");
            document.querySelector(".sub-tab-list").classList.add("hidden");
            document.querySelector(".js-product-select-nav").classList.remove("sub-menu-open");
            document.querySelector(".js-shield-tab-title").classList.remove("hidden");
            document.querySelector(".js-fragrance-mobile-tab-title").classList.add("hidden");
            document.querySelector(".js-product-select-nav").classList.contains("hide-slider-tabs") == true ? document.querySelector(".js-product-select-nav").classList.remove("hide-slider-tabs") : '';
            document.querySelector("body").classList.contains("hide-slider-tabs") == true ? document.querySelector("body").classList.remove("hide-slider-tabs") : '';
            
        },
        showSharePopup: function(event){
            document.querySelector(".js-share-image-model-main").classList.remove("hidden");
            document.querySelector("body").classList.add("share_content_model_open");
        },
        downloadContentImage: function(event){
            const _this = this;
            const firstProductJson = JSON.parse(localStorage.getItem("first-step-product")) ? JSON.parse(localStorage.getItem("first-step-product")) : JSON.parse(localStorage.getItem("save-design"))[0];
            const secondProductJson = JSON.parse(localStorage.getItem("second-step-product")) ? JSON.parse(localStorage.getItem("second-step-product")): JSON.parse(localStorage.getItem("save-design"))[1];
            const thirdProductJson = JSON.parse(localStorage.getItem("third-step-product")) ? JSON.parse(localStorage.getItem("third-step-product")) : JSON.parse(localStorage.getItem("save-design"))[2];
            let tag = secondProductJson.tags.find((arr)=>arr.includes("sh_"));
            let splitTag = tag.split("sh_");
            let imgEle1 = document.querySelector(".js-first-step").querySelector("img");
            let imgEle2 = document.querySelector(".js-second-step").querySelector("img");
            let imgEle3 = document.querySelector(".js-third-step").querySelector("img");
            let imgEle4 = document.querySelector(`#${splitTag[1]}`);
            let resEle = document.querySelector(".result");
            var context = resEle.getContext("2d");
            //resEle.width = imgEle1.width;
            //resEle.height = imgEle1.height;
            context.globalAlpha = 1.5;
            context.drawImage(imgEle3, 0, 0, 300, 300);
            context.globalAlpha = 1.0;
            context.drawImage(imgEle1, 50, 50, 200, 350);
            context.globalAlpha = 1;
            context.drawImage(imgEle2, 75, 120, 150, 150);
            context.globalAlpha = 1;
            context.drawImage(imgEle4, 103, 5, 90, 90);
            
            var canvas = document.getElementById('canvas');
            let fileName = 'Bottle-config-product.png'
            var context = canvas.getContext('2d');
                      
            /// create an "off-screen" anchor tag
            var lnk = document.createElement('a'), e;
    
            /// the key here is to set the download attribute of the a tag
            lnk.download = fileName;
    
            /// convert canvas content to data-uri for link. When download
            /// attribute is set the content pointed to by link will be
            /// pushed as "download" in HTML5 capable browsers
            lnk.href = canvas.toDataURL("image/png;base64");
            
            var base64Image = canvas.toDataURL("image/png;base64");
            
            document.getElementById("theimage").src = canvas.toDataURL("image/png;base64");
            
            const contentType = 'image/png'
            const byteCharacters = atob(base64Image.split(',')[1]);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += 512) {
                const slice = byteCharacters.slice(offset, offset + 512);

                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }
        
            // Convert Base64 to Blob
            const blob =  new Blob(byteArrays, { type: contentType });

            // Create a URL for the Blob
            const imageUrl = URL.createObjectURL(blob);
            
            // Display the image using the URL
            document.getElementById('theimage').src = imageUrl;
            
            lnk.click();
        },

       
    }
    bottleConfig.init();
})();